import { render } from "./SalonVideoPreview.vue?vue&type=template&id=e0f7fddc"
import script from "./SalonVideoPreview.vue?vue&type=script&lang=js"
export * from "./SalonVideoPreview.vue?vue&type=script&lang=js"

import "./SalonVideoPreview.vue?vue&type=style&index=0&id=e0f7fddc&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__